import { HotkeyBadgeWrapper } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadgeStyles';
import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';
import { DisplayName } from '../Option/OptionStyles';

export const CatcherThrowsOptionWrapper = styled.div`
  width: 46px;
  height: 52px;
  background: ${white};
  box-shadow: 0px 2px 15px 0 rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  line-height: 22px;
  position: relative;

  .option {
    border-radius: 5px;
  }

  &.disabled {
    opacity: 0.3;
    cursor: default;
    .display-name {
      cursor: default;
    }
    .hotkey-badge {
      cursor: default;
    }
  }
  ${DisplayName} {
    font-family: Oswald;
    font-weight: 500;
    font-size: 36px;
    color: ${darkgrey};
  }

  svg {
    display: none;
  }

  ${HotkeyBadgeWrapper} {
    float: none;
    margin: 0;
    position: absolute;
    bottom: -11px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
`;
